import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import axios from "axios";

export const CustomerContext = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);

  const [isAuthorized, setIsAuthorized] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const response = await axios.get(
        "/api/customer/check-auth",
        {
          withCredentials: true,
        },
      );

      const authenticated =
        response.data?.success === true &&
        response.data?.authenticated === true;

      setIsAuthorized(authenticated);

      setCustomer(authenticated ? response.data?.user || null : null);

      return authenticated;
    } catch (error) {
      console.error(
        "Customer auth check failed:",
        error.response?.data || error.message,
      );

      setIsAuthorized(false);
      setCustomer(null);

      return false;
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  return (
    <CustomerContext.Provider
      value={{
        customer,
        setCustomer,
        isAuthorized,
        setIsAuthorized,
        refreshUser,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  const context = useContext(CustomerContext);

  if (!context) {
    throw new Error("useCustomer must be used within a CustomerProvider");
  }

  return context;
};
